import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {
  selectEditingMobile,
  selectShowCanvasTooltip,
  selectUsedPremiumFeature,
} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {selectIsPremium} from '~/CreateFabricInvitation/reducers/fabricTemplate/selectors';
import {OneStepCreatePage} from '~/CreateFabricInvitation/routes/InvitationMaker/OneStepCreatePage/OneStepCreatePage';
import {EventCreateStickerParent} from '~/common/FabricInvitation/EventCreateDesign/components/Sticker/EventCreateStickerContext';
import {UpsellButtons} from '~/common/FabricInvitation/EventCreateDesign/components/UpsellButtons';
import {EventCreateParent} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {EventCreateDesign} from '~/common/FabricInvitation/EventCreateDesign/EventCreateDesign';
import {FontProvider} from '~/common/FabricInvitation/EventCreateDesign/FontProvider';
import {FabricContextParent} from '~/common/fabric/context/FabricContext';
import {selectEventId} from '~/common/fabric/EventGuests/reducers/guests/selectors';
import {OneStepContextParent} from '~/OneStepCreateInvitation/context/OneStepContext';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {ContentIdentifiers} from '~library/shared/enums/ContentIdentifiers';
import {TrackingEvents} from '~library/shared/enums/TrackingEvents';
import {sendTrackingData} from '~library/utils/tracking';

export const InvitationMakerEventCreateDesign = () => {
  const editingMobile = useSelector(selectEditingMobile);
  const showCanvasTooltip = useSelector(selectShowCanvasTooltip);
  const isDesktop = useIsLargishAndUp();

  const isPremium = useSelector(selectIsPremium);
  const usedPremiumFeature = useSelector(selectUsedPremiumFeature);

  const isMobileEditing = !isDesktop && editingMobile;
  const hiddenCreatePage = usedPremiumFeature && !isPremium;
  const eventId = useSelector(selectEventId);

  useEffect(() => {
    sendTrackingData(TrackingEvents.ContentLoadTracking, {
      identifier: ContentIdentifiers.CreateEditInvitationReview,
      attributes: {eventId},
    });
  }, [eventId]);

  return (
    <EventCreateParent>
      <EventCreateStickerParent>
        <FabricContextParent>
          <FontProvider>
            <EventCreateDesign
              showCanvasTooltip={showCanvasTooltip}
              scrollable={!isMobileEditing}
              UpsellButtons={UpsellButtons}
            >
              <OneStepContextParent>
                {!isMobileEditing && !hiddenCreatePage && <OneStepCreatePage />}
              </OneStepContextParent>
            </EventCreateDesign>
          </FontProvider>
        </FabricContextParent>
      </EventCreateStickerParent>
    </EventCreateParent>
  );
};
